var DealerLocatorTool = (function () {
  

  Utility.log('DealerLocatorTool loaded');

  var init = function () {
    var isDealerLocator = ($('dealer-locator-container').length > 0);

    if (isDealerLocator) {
      setListeners();
    }
  };

  var setListeners = function () {
    $(document).on('click', '.dealer-cta-raq', function (e) {
      $(e.currentTarget).attr('data-raq', 'true').attr('data-modal-type', 'large');

      $(document).trigger('activateModal', e);

      // remove the attribute so we don't trigger the modal twice on the next click
      $(e.currentTarget).removeAttr('data-modal-type');

      e.preventDefault();
    });
  };

  return {
    init: init,
  };
}());
